"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactHotLoader = require("react-hot-loader");

var _reactRedux = require("react-redux");

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _navigate = require("../../utils/routes/navigate");

var routes = _interopRequireWildcard(require("../../utils/routes"));

var _reactRouter = require("react-router");

var _ProjectSettings = _interopRequireDefault(require("./ProjectSettings"));

var _rules = require("../../context/settings/rules");

var _config = require("../../context/settings/config");

var _NotFound = _interopRequireDefault(require("../../containers/NotFound/NotFound"));

const TabBarNav = (0, _styledComponents.default)(_blocks.TabBar)`
  padding: 0 ${_blocks.spacing.extraLoose};
`;
const StyledThirds = (0, _styledComponents.default)(_blocks.Thirds)`
  padding: ${_blocks.spacing.default} 0;
`;
const LINKS = {
  [routes.InsightType.Insights]: {
    label: 'Insights',
    value: routes.InsightType.Insights,
    href: routes.SETTINGS_INSIGHTS,
    index: 0
  },
  [routes.InsightType.Monitoring]: {
    label: 'Monitoring',
    value: routes.InsightType.Monitoring,
    href: routes.SETTINGS_MONITORING,
    index: 1
  }
};

const ProjectSettingsView = ({
  match,
  appSetupComplete,
  user,
  sites,
  projects
}) => {
  if (!appSetupComplete) return null;
  const {
    insightType
  } = match.params;
  const link = LINKS[insightType]; // * 404 redirect if :insightType query parameter is invalid

  if (!link) {
    return /*#__PURE__*/React.createElement(_reactRouter.Redirect, {
      to: "/404"
    });
  }

  const current = link.index;
  const siteList = React.useMemo(() => Object.values(sites), [sites]);
  const projectList = React.useMemo(() => Object.values(projects), [projects]);
  const projectSettingAccess = user.access != null && user.groups !== undefined && user.rolesRestriction !== undefined && (user.rolesRestriction.includes('Administrators') || user.rolesRestriction.includes('Engineering Admins'));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_reactHelmet.default, {
    title: "Project Settings"
  }), /*#__PURE__*/React.createElement(_blocks.TertiaryNav, {
    hasBottomBorder: true
  }, /*#__PURE__*/React.createElement(StyledThirds, null, /*#__PURE__*/React.createElement(_blocks.Center, null, /*#__PURE__*/React.createElement(_blocks.DisplayMedium, null, "Project Settings")))), /*#__PURE__*/React.createElement(_blocks.TertiaryNav, null, /*#__PURE__*/React.createElement(TabBarNav, {
    current: current
  }, Object.values(LINKS).map(({
    href,
    label
  }) => /*#__PURE__*/React.createElement(_blocks.Tab, {
    key: href,
    onClick: (0, _navigate.navigate)(href)
  }, label)))), projectSettingAccess ? /*#__PURE__*/React.createElement(_config.ConfigProvider, null, /*#__PURE__*/React.createElement(_rules.RulesProvider, null, /*#__PURE__*/React.createElement(_ProjectSettings.default, {
    insightType: insightType,
    sites: sites,
    siteList: siteList,
    projectList: projectList
  }))) : /*#__PURE__*/React.createElement(_NotFound.default, null));
};

function mapStateToProps(state) {
  return {
    appSetupComplete: state.appSetup.appSetupComplete,
    sites: state.userSites.sites,
    projects: state.userSites.projects,
    user: state.auth.user
  };
}

var _default = (0, _reactHotLoader.hot)(module)((0, _reactRedux.connect)(mapStateToProps)(ProjectSettingsView));

exports.default = _default;
module.exports = exports.default;